<template>
  <button @click="baixarCsv">Exportar CSV</button>
</template>
<script>
import { exportChartConfigToCsv } from '../../helpers/exportCsvChart.js'

export default {
  name: 'Chart',
  props: {
    chartConfig: {
      type: Object,
      validator: function (value) {
        const keys = Object.keys(value)
        if (!keys.includes('type')) {
          console.error('[Chart.js] Object must has type (key)')
          return false
        }
        if (!keys.includes('data')) {
          console.error('[Chart.js] Object must has data (key)')
          return false
        }
        return true
      }
    },
    delimiter: {
      type: String,
      default: ';'
    }
  },
  mounted () {
  },
  methods: {
    baixarCsv() {
      exportChartConfigToCsv(this.chartConfig, this.chartConfig.fileName, this.delimiter, this.chartConfig.customHeader)
    }
  }
}
</script>
<style lang="css">
</style>



// WEBPACK FOOTER //
// VAChartCsv.vue?3b75abbc